import React from "react";
import { UseFormRegister, FieldErrors, Control, useFieldArray } from "react-hook-form";
import InputField from "../../../components/form/InputField";
import InputPhoneField from "../../../components/form/InputPhoneField";
import ButtonSelect from "../../../components/form/ButtonSelect";
import SubTitle from "../../../components/ui/SubTitle";
import { Page2FormData } from "../../../pages/owner/store/CreateStorePageTwo";
import { useTranslation } from "react-i18next";
import { category } from "../../../types/modules/Category";
import { SubCategory } from "../../../types/modules/SubCategory";
import { Sector } from "../../../types/modules/sector.type";

interface Props {
  register: UseFormRegister<Page2FormData>;
  errors: FieldErrors<Page2FormData>;
  control: Control<Page2FormData>;
  selectedCategory: number | null;
  onSelectCategory: (id: number) => void;
  filteredSubTypes: SubCategory[];
  selectedSubTypeId: number | null;
  onSelectSubType: (id: number) => void;
  selectedSectorId?:number|null,
  onSelectSector?:(id:number)=>void,
  categories: category[];
  sectors?:Sector[]
}

const StorePageTwoForm: React.FC<Props> = ({
  register,
  errors,
  control,
  selectedCategory,
  onSelectCategory,
  filteredSubTypes,
  selectedSubTypeId,
  onSelectSubType,
  categories,
  selectedSectorId,
  onSelectSector,
  sectors
}) => {
  const { fields } = useFieldArray({ control, name: "name" });
  const { t } = useTranslation();

  return (
    <>
      <div className="grid md:grid-cols-2 gap-5">
        {fields.map((field, idx) => (
        <div key={field.id} className="mb-4">
          <InputField
            label={`${t('storeBranch')} (${field.languageCode})`}
            placeholder={`${t('storeBranchPlaceholder')} (${field.languageCode})`}
            register={register(`name.${idx}.name`, { required: `${t('required_field')}` })}
            error={errors.name?.[idx]?.name}
          />
          
          
          <input type="hidden" {...register(`name.${idx}.languageCode`)} value={field.languageCode} />
        </div>
      ))}
      </div>

      <div>
        <SubTitle title="StorePhoneNumber" />
        <div dir="ltr">
          <InputPhoneField
            placeholder="55 333 4444"
            register={register("phone", {
              required: t("required_field"),
              pattern: {
                value: /^\d{9}$/,
                message: t("invalid_format"), // or a custom message like "Phone must be 9 digits"
              },
            })}
            error={errors.phone}
            rounded={8}
          />
        </div>
      </div>

      <div>
        <SubTitle title={t("select_category")} />
        <ButtonSelect
          options={categories.map(c => ({ id: c.id, label: c.languages[0].name, image: c.iconUrl }))}
          selected={selectedCategory}
          onSelect={onSelectCategory}
        />
      </div>

      <div>
        <SubTitle title={t("select_subtype")} />
        <ButtonSelect
          options={filteredSubTypes.map(s => ({ id: s.id, label: s.languages[0].name }))}
          selected={selectedSubTypeId}
          onSelect={onSelectSubType}
        />
      </div>

      {
        (sectors && selectedSectorId && onSelectSector)&&
        <div>
        <SubTitle title={t("sector_type")} />
        <ButtonSelect
          options={sectors.map(s => ({ id: s.id, label: s.languages[0].name }))}
          selected={selectedSectorId}
          onSelect={onSelectSector}
        />
      </div>
      }
    </>
  );
};

export default StorePageTwoForm;
